import { cx } from "@/lib/cx";

/**
 * An item key ("NWS-12") in Geist Mono with tabular figures. `width` (in characters) aligns a
 * column of keys in lists; omit it inline.
 */
export function ItemKey({ value, width, className }: { value: string; width?: number; className?: string }) {
  return (
    <span
      className={cx("shrink-0 font-mono text-xs text-fg-muted tnum whitespace-nowrap", className)}
      style={width ? { minWidth: `${width}ch` } : undefined}
    >
      {value}
    </span>
  );
}
